import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Divider, Image, Paper, Stack, Text, rem } from '@mantine/core';
import { ProfileCharacter } from './ProfileCharacter';
export const ProfileCongrats: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack h={{
    base: 'calc(100vh - 110px)',
    lg: 'calc(100vh - 190px)'
  }} gap={10} bg={{
    sm: 'var(--bg-200)',
    lg: 'transparent'
  }} p={{
    base: 24,
    sm: 20
  }}>
      <Image src="/assets/kyc/shield.svg" alt="shield" w={{
      base: 80,
      sm: 100,
      lg: 112
    }} h={{
      base: 80,
      sm: 100,
      lg: 112
    }} />
      <Box>
        <Text fz={{
        sm: rem(20),
        lg: rem(32)
      }} c="var(--text-prime)" className={gunterzBold.className}>
          {i18n._('Congrats, ')}
          <Text c="var(--text-white)" span inherit>
            {i18n._('you’re Armored up!')}
          </Text>
        </Text>
      </Box>

      <Divider size="sm" c="var(--icon-primary)" />

      <Text fz={{
      sm: rem(18),
      lg: rem(20)
    }} c="var(--text-dark)" className={gunterzBold.className}>
        {i18n._('You’ve unlocked a ')}
        <Text span inherit c="var(--text-pink)">
          {i18n._('LEGENDARY ')}
        </Text>
        {i18n._('ARMOR!')}
      </Text>

      <Divider size="sm" c="var(--icon-primary)" />

      <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700}>
        {i18n._('Your PrimeOrb is now equipped and ready for battle. Want to push it even further? ')}
      </Text>

      <Text fz="xs" c="var(--text-prime)" tt="uppercase" fw={700}>
        {i18n._('Play for more exclusive items in the Lootboxes or head to the Bunker to customize and upgrade your PrimeOrb')}

        <Text span inherit c="var(--text-dark)">
          {i18n._(' for ultimate performance.')}
        </Text>
      </Text>

      <Paper visibleFrom="lg" p={{
      base: 10,
      lg: 20
    }} mt={{
      base: 16,
      lg: 30
    }} radius={5} bg="transparent" bd="1px solid var(--icon-primary)">
        <Text fz="xs" fw={700} c="var(--text-prime)" tt="uppercase">
          {i18n._('rarity')}
        </Text>
        <Text fz={{
        base: 'sm',
        lg: 'lg'
      }} className={gunterzBold.className}>
          {i18n._('legendary')}
        </Text>

        <Text fz="xs" fw={700} c="var(--text-prime)" tt="uppercase" mt={{
        base: 16,
        lg: 24
      }}>
          {i18n._('rewards')}
        </Text>
        <Text fz={{
        base: 'sm',
        lg: 'lg'
      }} className={gunterzBold.className}>
          {i18n._('250 prll + 5% rakeback')}
        </Text>
      </Paper>

      <ProfileCharacter visible="sm" hidden="lg" />
    </Stack>;
};